export default "__VITE_ASSET__DsNBnf_d__"